import React from "react";

export { getRobotExtraInfoType } from "../config/lawnRobots";

export function RobotExtraInfo({ extraInfoType, rmaCode }) {
  if (!extraInfoType) return null;

  return (
    <div className="mt-6">
      {extraInfoType === "dck" && (
        <RobotInfoBox>
          <RobotInfoIntro />
          <ol className="list-decimal pl-5 space-y-2">
            <li>
              <strong>LOG failus / darbo žurnalą</strong> – instrukcija:{" "}
              <a
                href="https://www.youtube.com/watch?v=veSFNcalmNs"
                target="_blank"
                rel="noreferrer"
                className="text-blue-700 underline"
              >
                YouTube video
              </a>
            </li>
            <li><strong>Klaidų informaciją</strong> arba klaidos nuotrauką.</li>
            <li>Teritorijos nuotraukas iš vietos, kur robotas stringa.</li>
            <li><strong>LIDAR stikliuko nuotrauką.</strong></li>
            <li><strong>Dabartinio žemėlapio ekrano nuotrauką.</strong></li>
          </ol>
          <RobotInfoFooter rmaCode={rmaCode} />
        </RobotInfoBox>
      )}

      {extraInfoType === "terramow" && (
        <RobotInfoBox>
          <RobotInfoIntro />
          <ol className="list-decimal pl-5 space-y-2">
            <li><strong>LOG failus</strong> – iš programėlės prisijungus prie roboto.</li>
            <li><strong>Klaidų informaciją</strong> arba klaidos nuotrauką.</li>
            <li>Teritorijos nuotraukas iš vietos, kur robotas stringa.</li>
            <li><strong>Probleminės vietos realią nuotrauką.</strong></li>
            <li><strong>Dabartinio žemėlapio ekrano nuotrauką.</strong></li>
            <li><strong>Programėlėje užregistruoto vartotojo el. paštą.</strong></li>
          </ol>
          <RobotInfoFooter rmaCode={rmaCode} />
        </RobotInfoBox>
      )}

      {(extraInfoType === "segway" || extraInfoType === "sunseeker") && (
        <RobotInfoBox>
          <RobotInfoIntro />
          <ol className="list-decimal pl-5 space-y-2">
            <li><strong>Klaidų informaciją</strong> arba klaidos nuotrauką.</li>
            <li>Teritorijos nuotraukas iš vietos, kur robotas stringa.</li>
            <li><strong>Probleminės vietos realią nuotrauką.</strong></li>
            <li><strong>Dabartinio žemėlapio ekrano nuotrauką.</strong></li>
          </ol>
          <RobotInfoFooter rmaCode={rmaCode} />
        </RobotInfoBox>
      )}

      {extraInfoType === "mova" && (
        <div className="bg-orange-50 border border-orange-300 rounded-xl p-5 text-orange-900">
          <h3 className="text-lg font-bold mb-3">
            MOVA / Dreame robotų serviso informacija
          </h3>

          <p>
            Šių robotų garantinis servisas atliekamas per{" "}
            <strong>LTSC.lt servisą</strong>. Rekomenduojame registruotis
            tiesiogiai pas juos.
          </p>

          <div className="mt-4 bg-white border rounded-lg p-4 space-y-1">
            <p className="font-semibold">MOVA / Dreame garantinis servisas</p>
            <p>
              Svetainė:{" "}
              <a href="https://www.ltsc.lt" target="_blank" rel="noreferrer" className="text-blue-700 underline">
                www.ltsc.lt
              </a>
            </p>
            <p>Tel.: +370 521 95 332</p>
            <p>El. paštas: info@ltsc.lt</p>
          </div>
        </div>
      )}
    </div>
  );
}

function RobotInfoBox({ children }) {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-5 text-gray-800 leading-6">
      {children}
    </div>
  );
}

function RobotInfoIntro() {
  return (
    <p className="mb-4">
      <strong>
        Kad serviso procesas vyktų sklandžiau, rekomenduojame pateikti šią informaciją:
      </strong>
    </p>
  );
}

function RobotInfoFooter({ rmaCode }) {
  return (
    <>
      <p className="mt-4 italic text-gray-700">
        Ši informacija rekomendacinė, tačiau gali ženkliai paspartinti diagnostiką.
      </p>

      <p className="mt-4">
        Informaciją galite įkelti šiame statuso puslapyje, nurodę{" "}
        <strong>RMA kodą {rmaCode}</strong> ir paskutinius 4 telefono numerio skaitmenis.
      </p>
    </>
  );
}